import React from "react";
import styled from "@emotion/styled";
import { LanguageSelector } from "./LanguageSelector";
import { Logo } from './Logo';
import { PhoneNumber } from './PhoneNumber';
import { ContactUs } from './ContactUs';
import { CurrencySelector } from "./CurrencySelector";
import { ChatWithUs } from "./ChatWithUs";
import { Tagline } from "./Tagline";
import { LocaleContext } from "../Context/Locale";
import withFosRouter from "../FosRouter/withFosRouting";
import { ParameterContext } from "../Context/Parameter";
import { RenderContext } from "../Context/Ssr";
import { GoogleReviewsBadge } from "./GoogleReviewsBadge";

const TopOptions = styled.div`
    display: flex;
    flex-direction: row;
    width:100%;
    justify-content: space-between;
    height: auto;
    position: relative;
    @media (min-width: 768px) {
      margin-right:50px;
    }
`;

const TopMenu = styled.div`
    position:relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-self:center;
`;

const TopMenuItem = styled.div`
    color: white;
    align-self:center;
`;
const TopMenuItemBoxed = styled.div`
    color: white;
    align-self:center;
    max-width:82px;
    width:82px;
`;
var hstyle = {
    height: '20px'
};

class TopOptionsBarComponent extends React.Component {
    constructor(props) {
        super(props);
    }
        
    render() {
        const { r } = this.props;

        return (
        <TopOptions className="bg-white px-3 py-2">
            <div className="flex items-fend">
                <Logo link={r('homepage')} searchURLBase={this.props.searchURLBase}/>
                <Tagline className="font-80 pl-2" mobile={false}/>
            </div>
            <GoogleReviewsBadge className="flex flex-sm-column width-fitcontent pl-2 font-80" locale={this.props.locale} rating={4.8} />
          <TopMenu>
              <TopMenuItem>
                  <ChatWithUs 
                  height="20" 
                  width="24" 
                  iconColor={this.props.chatWithUsLabel !== 'livechat_offline' ? "green3" : "blue3"}
                  label={this.props.chatWithUsLabel}
                  searchURLBase={this.props.searchURLBase}
                  className="blue1"/>
              </TopMenuItem>
              <TopMenuItem className="ml-4">
                    { ['en','nl','fr','ru','de','da','no','it','es','ca_es'].includes(this.props.locale)  ? (
                            <PhoneNumber
                            height="20"
                            width="20"
                            iconColor="blue3"
                            searchURLBase={this.props.searchURLBase}
                            locale={this.props.locale}
                            tooltipEnabled={true}
                            />
                        ) : (
                            <ContactUs
                            height="20"
                            width="20"
                            iconColor="blue3"
                            searchURLBase={this.props.searchURLBase}
                            locale={this.props.locale}
                            />
                        )
                    }
              </TopMenuItem>
              <TopMenuItemBoxed className="ml-4">
                  <CurrencySelector 
                  className="bg-white py-2 px-2 bor-no btn-no no-select-handle font-90 font-w600 blue1" 
                  style={{ height:'36px'}}
                  currency={this.props.currency}
                  />
              </TopMenuItemBoxed>
              <TopMenuItemBoxed className="ml-4">
                <RenderContext.Consumer>
                    {value => {
                        let renderContext = value;
                        return (
                <ParameterContext.Consumer>
                    { value => {
                        let parameter = value;
                        return (
                            <LocaleContext.Consumer>
                                {  value => {
                                        return (
                                            <LanguageSelector
                                                mobile={false}
                                                landingPagesIntl={this.props.landingPagesIntl}
                                                aiLandingpagesIntl={this.props.aiLandingpagesIntl}
                                                languageSelectorOptions={this.props.languageSelectorOptions}
                                                buttonClassName="inline-block"
                                                locale={value}
                                                parameter={parameter}
                                                renderContext={renderContext}
                                                searchURLBase={this.props.searchURLBase}        
                                            />
                                    );
                                    }
                                }
                            </LocaleContext.Consumer>
                        );
                        }
                    }
                </ParameterContext.Consumer>)
                }}
                </RenderContext.Consumer>
              </TopMenuItemBoxed>
          </TopMenu>
        </TopOptions>
        );
    }
}

export const TopOptionsBar = withFosRouter(TopOptionsBarComponent);